import { initializeApp } from 'firebase/app';
import {
  collection,
  getDocs,
  getFirestore,
} from 'firebase/firestore';

const deviceUpdate = document.getElementById("deviceUpdate") as HTMLButtonElement;
const dongleUpdate = document.getElementById("dongleUpdate") as HTMLButtonElement;
const consoleStartButton = document.getElementById("consoleStartButton") as HTMLButtonElement;
const consoleStopButton = document.getElementById("consoleStopButton") as HTMLButtonElement;
const terminal = document.getElementById("terminal");
const programDiv = document.getElementById("program");
const consoleDiv = document.getElementById("console");
const lblConsoleBaudrate = document.getElementById("lblConsoleBaudrate");
const lblConsoleFor = document.getElementById("lblConsoleFor");
var airmotionUpdateProg = document.getElementById("myBarAirmotion");
var deviceUpdateProg = document.getElementById("myBarDevice");
airmotionUpdateProg.style.display = "none";
deviceUpdateProg.style.display = "none";
//terminal.style.display = "none";
// hide console area by default
consoleDiv.style.display = "none";
// hide the start button initially
consoleStartButton.style.display = "none";
var DeviceMac;
var deviceAuth = false;
var deviceS3Found = true;
// This is a frontend example of Esptool-JS using local bundle file
// To optimize use a CDN hosted version like
// https://unpkg.com/esptool-js@0.2.0/bundle.js
import { ESPLoader, FlashOptions, LoaderOptions, Transport } from "../../../lib";
import { serial } from "web-serial-polyfill";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
if (!(navigator as any).serial && (navigator as any).usb) (navigator as any).serial = serial;

declare let Terminal; // Terminal is imported in HTML script
declare let CryptoJS; // CryptoJS is imported in HTML script
const firebaseConfig = {
  apiKey: "AIzaSyA5ULkaeEvPZQD7hCElrtrw9Yf4-OxaXYo",
  authDomain: "breathcontrol-95f8d.firebaseapp.com",
  projectId: "breathcontrol-95f8d",
  storageBucket: "breathcontrol-95f8d.appspot.com",
  messagingSenderId: "950703477235",
  appId: "1:950703477235:web:cb071bc9a1898bed300286",
  measurementId: "G-NF2XQREHS3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
let db = getFirestore(app);
export { app, db }
const term = new Terminal({ cols: 120, rows: 40 });
term.open(terminal);

let device = null;
let transport: Transport;
let esploader: ESPLoader;

var appbinary;
var partitionbinary;
var bootbinary;
var app0binary;
// legacy vars removed; fake-intervals drive the initial animation
let _fakeIntervalA: number | null = null;
let _fakeIntervalD: number | null = null;
function setProgress(id: string, value: number) {
  const el = document.getElementById(id) as HTMLElement;
  if (!el) return;
  el.style.width = value + "%";
  el.setAttribute('aria-valuenow', String(value));
  el.textContent = value ? String(value) + "%" : "";
  // clear any fake progress animations so they don't overwrite real progress
  if (value > 0) {
    if (_fakeIntervalA) {
      clearInterval(_fakeIntervalA);
      _fakeIntervalA = null;
    }
    if (_fakeIntervalD) {
      clearInterval(_fakeIntervalD);
      _fakeIntervalD = null;
    }
  }
}
// removed aggregated reporter; progress will be per-file and we'll compute a simple
// total progress as the average of each file's percent to show overall progress.
function showSpinner(text?: string) {
  const el = document.getElementById('spinnerOverlay');
  if (!el) return;
  const txt = el.querySelector('.spinner-text') as HTMLElement;
  if (txt && text) txt.textContent = text;
  el.classList.remove('d-none');
}
function hideSpinner() {
  const el = document.getElementById('spinnerOverlay');
  if (!el) return;
  el.classList.add('d-none');
}
function showStatus(message: string, type: 'info' | 'success' | 'error' = 'info', timeout = 5000) {
  const container = document.getElementById('statusAlert');
  if (!container) return;
  const bsClass = type === 'error' ? 'danger' : type === 'success' ? 'success' : 'info';
  const id = `status-${Date.now()}`;
  container.innerHTML = `
    <div id="${id}" class="alert alert-${bsClass} alert-dismissible fade show" role="alert">
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`;
  if (timeout && timeout > 0) {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.remove();
    }, timeout);
  }
}
function move() {
  // Start a small fake progress animation while the port picker / connect occurs.
  if (_fakeIntervalA) return;
  let fake = 0;
  _fakeIntervalA = window.setInterval(() => {
    fake = Math.min(8, fake + 1);
    try {
      if (airmotionUpdateProg) airmotionUpdateProg.style.width = fake + "%";
    } catch (e) {}
    if (fake >= 8 && _fakeIntervalA) {
      clearInterval(_fakeIntervalA);
      _fakeIntervalA = null;
    }
  }, 200);
}

function moveDongle() {
  if (_fakeIntervalD) return;
  let fake = 0;
  _fakeIntervalD = window.setInterval(() => {
    fake = Math.min(8, fake + 1);
    try {
      if (deviceUpdateProg) deviceUpdateProg.style.width = fake + "%";
    } catch (e) {}
    if (fake >= 8 && _fakeIntervalD) {
      clearInterval(_fakeIntervalD);
      _fakeIntervalD = null;
    }
  }, 200);
}

consoleStopButton.style.display = "none";

const Device_url = "https://chaabanihoussem.github.io/QAhajeQ9G/airmotion/airmotion.bin"
const Device_boot_url = "https://chaabanihoussem.github.io/QAhajeQ9G/airmotion/airmotion_boot.bin"
const Device_part_url = "https://chaabanihoussem.github.io/QAhajeQ9G/airmotion/airmotion_part.bin"
const Device_app0_url = "https://chaabanihoussem.github.io/QAhajeQ9G/airmotion/airmotion_app0.bin"

const Dongle_url = "https://chaabanihoussem.github.io/QAhajeQ9G/dongle/dongle.bin"
const Dongle_part_url = "https://chaabanihoussem.github.io/QAhajeQ9G/dongle/dongle_part.bin"
const Dongle_boot_url = "https://chaabanihoussem.github.io/QAhajeQ9G/dongle/dongle_boot.bin"
const Dongle_app0_url = "https://chaabanihoussem.github.io/QAhajeQ9G/dongle/dongle_app0.bin"

const Device_S3_url = "https://chaabanihoussem.github.io/QAhajeQ9G/deviceS3/airmotion_S3.bin"
const Device_S3_boot_url = "https://chaabanihoussem.github.io/QAhajeQ9G/deviceS3/airmotion_S3_boot.bin"
const Device_S3_part_url = "https://chaabanihoussem.github.io/QAhajeQ9G/deviceS3/airmotion_S3_part.bin"
const Device_S3_app0_url = "https://chaabanihoussem.github.io/QAhajeQ9G/deviceS3/airmotion_S3_app0.bin"

const espLoaderTerminal = {
  clean() {
    term.clear();
  },
  writeLine(data) {
    term.writeln(data);
  },
  write(data) {
    term.write(data);
  },
};

// Prefetch promises started on page load to reduce waiting time later.
let prefetchDeviceS3: Promise<any[]> | null = null;
let prefetchDeviceC3: Promise<any[]> | null = null;
let prefetchDongle: Promise<any[]> | null = null;

function startPrefetch() {
  try {
    prefetchDeviceS3 = Promise.all([
      fetchBinaryFile(Device_S3_url),
      fetchBinaryFile(Device_S3_boot_url),
      fetchBinaryFile(Device_S3_part_url),
      fetchBinaryFile(Device_S3_app0_url),
    ]).then((results) => results)
      .catch((err) => {
        console.error('prefetchDeviceS3 failed', err);
        prefetchDeviceS3 = null;
        throw err;
      });

    prefetchDeviceC3 = Promise.all([
      fetchBinaryFile(Device_url),
      fetchBinaryFile(Device_boot_url),
      fetchBinaryFile(Device_part_url),
      fetchBinaryFile(Device_app0_url),
    ]).then((results) => results)
      .catch((err) => {
        console.error('prefetchDeviceC3 failed', err);
        prefetchDeviceC3 = null;
        throw err;
      });

    prefetchDongle = Promise.all([
      fetchBinaryFile(Dongle_url),
      fetchBinaryFile(Dongle_boot_url),
      fetchBinaryFile(Dongle_part_url),
      fetchBinaryFile(Dongle_app0_url),
    ]).then((results) => results)
      .catch((err) => {
        console.error('prefetchDongle failed', err);
        prefetchDongle = null;
        throw err;
      });
  } catch (e) {
    console.error('startPrefetch error', e);
  }
}

// Start fetching firmware right away on page load
startPrefetch();



deviceUpdate.onclick = async () => {
  var chip:string;
  // disable buttons and start UX feedback immediately
  deviceUpdate.disabled = true;
  dongleUpdate.disabled = true;
  showSpinner('Waiting for port selection...');

  // reuse global prefetch promises started on load (or start new ones)
  prefetchDeviceS3 = prefetchDeviceS3 ?? Promise.all([
    fetchBinaryFile(Device_S3_url),
    fetchBinaryFile(Device_S3_boot_url),
    fetchBinaryFile(Device_S3_part_url),
    fetchBinaryFile(Device_S3_app0_url),
  ]).then(r => r).catch(err=>{ prefetchDeviceS3 = null; throw err; });
  prefetchDeviceC3 = prefetchDeviceC3 ?? Promise.all([
    fetchBinaryFile(Device_url),
    fetchBinaryFile(Device_boot_url),
    fetchBinaryFile(Device_part_url),
    fetchBinaryFile(Device_app0_url),
  ]).then(r => r).catch(err=>{ prefetchDeviceC3 = null; throw err; });
  const prefetchS3 = prefetchDeviceS3;
  const prefetchC3 = prefetchDeviceC3;

  if (device === null) {
    // show spinner while the browser port picker appears
    showSpinner('Waiting for port selection...');
    device = await navigator.serial.requestPort({});
    transport = new Transport(device, true);
  }
  showSpinner('Connecting to device...');
  move();
  try {
    const flashOptions = {
      transport,
      baudrate: 921600,
      terminal: espLoaderTerminal,
    } as LoaderOptions;
    esploader = new ESPLoader(flashOptions);
    showSpinner('Identifying device...');
    chip = await esploader.main();
    DeviceMac = (await esploader.getmac()).toUpperCase();
    showSpinner(`Identified: ${DeviceMac}`);
    term.writeln(chip);
    term.writeln(DeviceMac);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error connecting to device: ${e.message}`, 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }
  console.log("Settings done for :" + chip);
  if (chip.includes('ESP32-S3')) {
    deviceS3Found = true;
    // use prefetched binaries when available
    try {
      [appbinary, bootbinary, partitionbinary, app0binary] = await prefetchS3;
    } catch (err) {
      // fallback to individual fetches
      appbinary = await fetchBinaryFile(Device_S3_url);
      bootbinary = await fetchBinaryFile(Device_S3_boot_url);
      partitionbinary = await fetchBinaryFile(Device_S3_part_url);
      app0binary = await fetchBinaryFile(Device_S3_app0_url);
    }
    await esploader.eraseFlash();
    showSpinner('Preparing to update ...');
  } else if (chip.includes('ESP32-C3')) {
    try {
      [appbinary, bootbinary, partitionbinary, app0binary] = await prefetchC3;
    } catch (err) {
      appbinary = await fetchBinaryFile(Device_url);
      bootbinary = await fetchBinaryFile(Device_boot_url);
      partitionbinary = await fetchBinaryFile(Device_part_url);
      app0binary = await fetchBinaryFile(Device_app0_url);
    }
  } else {
    hideSpinner();
    showStatus('Wrong device detected — please select the correct serial port.', 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  signInWithEmailAndPassword(auth, "oneuser@papritech.com", "fasjdklfjltert13g8d6fg0o54w5# # #")
    .then(async () => {
      try {
        const collectionRef = collection(db, "devices")
        const querySnapshot = await getDocs(collectionRef)
        for (var queryDocumentSnapshot in querySnapshot.docs) {
          const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          var macAddress = data[queryDocumentSnapshot].id;
          if (macAddress == DeviceMac) {
            term.writeln(`device found ${DeviceMac}`);
            deviceAuth = true;
          }

        }
        if (deviceS3Found) {
          doDeviceUpdate(); 
        }else
        if (!deviceAuth) {
          term.writeln(`device 1 not found ${DeviceMac}`);
          hideSpinner();
          alert("This is not A Papritech device");
          return;
        }else{
          doDeviceUpdate();
        }
        console.log('querySnapshot.size:', querySnapshot.size);

      } catch (ex) {
        console.error(`ERROR getDocuments():: ${ex.message}`);
      }
    })
    .catch((error) => {
      console.error(error);
    });

  };

  async function doDeviceUpdate(){
  deviceUpdate.style.display = "none";
  // keep console hidden during update
  consoleDiv.style.display = "none";
  airmotionUpdateProg.style.display = "block";
  showSpinner('Updating firmware...');
  // Flash each firmware file separately (original behavior) and update a
  // "Total progress" bar as the simple average of each file's percent.
  const totalPercents = [0, 0, 0, 0];

  // APP
  try {
    const fileArrayAPP = [];
    const offsetApp = parseInt('0x10000');
    fileArrayAPP.push({ data: appbinary, address: offsetApp });
    const flashOptionsAPP: FlashOptions = {
      fileArray: fileArrayAPP,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarAirmotion', pct);
        totalPercents[0] = pct;
        const avg = Math.round(totalPercents.reduce((a, b) => a + b, 0) / totalPercents.length);
        setProgress('myBarAirmotionTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsAPP);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  // BOOT
  try {
    const fileArrayBoot = [];
    const offsetBoot = parseInt('0x0');
    fileArrayBoot.push({ data: bootbinary, address: offsetBoot });
    const flashOptionsBoot: FlashOptions = {
      fileArray: fileArrayBoot,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarAirmotion', pct);
        totalPercents[1] = pct;
        const avg = Math.round(totalPercents.reduce((a, b) => a + b, 0) / totalPercents.length);
        setProgress('myBarAirmotionTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsBoot);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  // PARTITION
  try {
    const fileArraypart = [];
    const offsetpart = parseInt('0x8000');
    fileArraypart.push({ data: partitionbinary, address: offsetpart });
    const flashOptionsPart: FlashOptions = {
      fileArray: fileArraypart,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarAirmotion', pct);
        totalPercents[2] = pct;
        const avg = Math.round(totalPercents.reduce((a, b) => a + b, 0) / totalPercents.length);
        setProgress('myBarAirmotionTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsPart);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  // APP0
  try {
    const fileArrayApp0 = [];
    const offsetApp0 = parseInt('0xe000');
    fileArrayApp0.push({ data: app0binary, address: offsetApp0 });
    const flashOptionsApp0: FlashOptions = {
      fileArray: fileArrayApp0,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarAirmotion', pct);
        totalPercents[3] = pct;
        const avg = Math.round(totalPercents.reduce((a, b) => a + b, 0) / totalPercents.length);
        setProgress('myBarAirmotionTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsApp0);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  } finally {
    hideSpinner();
    showStatus('Device updated successfully — please restart the device.', 'success', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
  }

};

dongleUpdate.onclick = async () => {
  // disable buttons and show immediate feedback
  deviceUpdate.disabled = true;
  dongleUpdate.disabled = true;
  showSpinner('Preparing firmware...');
  // start fetching dongle firmware early (reuse global prefetch if available)
  prefetchDongle = prefetchDongle ?? Promise.all([
    fetchBinaryFile(Dongle_url),
    fetchBinaryFile(Dongle_boot_url),
    fetchBinaryFile(Dongle_part_url),
    fetchBinaryFile(Dongle_app0_url),
  ]).then(r => r).catch(err=>{ prefetchDongle = null; throw err; });
  const donglePrefetch = prefetchDongle;
  let chip;
  if (device === null) {
    showSpinner('Waiting for port selection...');
    device = await navigator.serial.requestPort({});
    transport = new Transport(device, true);
  }
  showSpinner('Connecting to dongle...');
  moveDongle();
  try {
    const flashOptions = {
      transport,
      baudrate: 921600,
      terminal: espLoaderTerminal,
    } as LoaderOptions;
    esploader = new ESPLoader(flashOptions);
    showSpinner('Identifying dongle...');
    chip = await esploader.main();
    DeviceMac = (await esploader.getmac()).toUpperCase();
    term.writeln(chip);
    showSpinner(`Identified: ${DeviceMac}`);
    term.writeln(DeviceMac);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error connecting to dongle: ${e.message}`, 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }
  console.log("Settings done for :" + chip);

  if (!chip.includes('ESP32-S3')) {
    hideSpinner();
    showStatus('Wrong device detected — please select the correct serial port.', 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }
  signInWithEmailAndPassword(auth, "oneuser@papritech.com", "fasjdklfjltert13g8d6fg0o54w5# # #")
    .then(async () => {
      try {
        const collectionRef = collection(db, "devices")
        const querySnapshot = await getDocs(collectionRef)
        for (var queryDocumentSnapshot in querySnapshot.docs) {
          const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          var macAddress = data[queryDocumentSnapshot].id;
          term.writeln(`device ${macAddress}`);
          if (macAddress == DeviceMac) {
            term.writeln(`device found ${DeviceMac}`);
            deviceAuth = true;
          }

        }
        if (!deviceAuth) {
          term.writeln(`device 2 not found ${DeviceMac}`);
          hideSpinner();
          showStatus('This is not a Papritech device.', 'error', 6000);
          deviceUpdate.disabled = false;
          dongleUpdate.disabled = false;
          return;
        } else {
          // ensure firmware was prefetched and assign binaries if available
          try {
            const results = await donglePrefetch;
            appbinary = results[0];
            bootbinary = results[1];
            partitionbinary = results[2];
            app0binary = results[3];
          } catch (err) {
            // if prefetch failed, the doDongleUpdate will fetch as before
          }
          doDongleUpdate();
        }
        console.log('querySnapshot.size:', querySnapshot.size);

      } catch (ex) {
        console.error(`ERROR getDocuments():: ${ex.message}`);
      }

      // ...
    })
    .catch((error) => {
      console.error(error);
      // ...
    });
  };


async function doDongleUpdate(){
  dongleUpdate.style.display = "none";
  // keep console hidden during update
  consoleDiv.style.display = "none";
  deviceUpdateProg.style.display = "block";
  showSpinner('Updating  Please wait ...');
  // Flash dongle files separately and update a total progress bar below.
  const totalPercentsDevice = [0, 0, 0, 0];

  // APP
  try {
    const fileArrayAPP = [] as Array<{data:any,address:number}>;
    fileArrayAPP.push({ data: appbinary, address: parseInt('0x10000') });
    const flashOptionsAPP: FlashOptions = {
      fileArray: fileArrayAPP,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarDevice', pct);
        totalPercentsDevice[0] = pct;
        const avg = Math.round(totalPercentsDevice.reduce((a, b) => a + b, 0) / totalPercentsDevice.length);
        setProgress('myBarDeviceTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsAPP);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  // BOOT
  try {
    const fileArrayBoot = [] as Array<{data:any,address:number}>;
    fileArrayBoot.push({ data: bootbinary, address: parseInt('0x0') });
    const flashOptionsBoot: FlashOptions = {
      fileArray: fileArrayBoot,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarDevice', pct);
        totalPercentsDevice[1] = pct;
        const avg = Math.round(totalPercentsDevice.reduce((a, b) => a + b, 0) / totalPercentsDevice.length);
        setProgress('myBarDeviceTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsBoot);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 8000);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  }

  

  // PARTITION
  try {
    const fileArraypart = [] as Array<{data:any,address:number}>;
    fileArraypart.push({ data: partitionbinary, address: parseInt('0x8000') });
    const flashOptionsPart: FlashOptions = {
      fileArray: fileArraypart,
      flashSize: "keep",
      eraseAll: false,
      compress: true,
      reportProgress: (fileIndex, written, total) => {
        const pct = total ? Math.round((written / total) * 100) : 0;
        setProgress('myBarDevice', pct);
        totalPercentsDevice[2] = pct;
        const avg = Math.round(totalPercentsDevice.reduce((a, b) => a + b, 0) / totalPercentsDevice.length);
        setProgress('myBarDeviceTotal', avg);
        term.writeln(`percentage: ${pct}`);
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    await esploader.writeFlash(flashOptionsPart);
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
    hideSpinner();
    showStatus(`Error: ${e.message}`, 'error', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
    return;
  } finally {
    // APP0
    try {
      const fileArrayApp0 = [] as Array<{data:any,address:number}>;
      const offsetApp0 = parseInt('0xe000');
      fileArrayApp0.push({ data: app0binary, address: offsetApp0 });
      const flashOptionsApp0: FlashOptions = {
        fileArray: fileArrayApp0,
        flashSize: "keep",
        eraseAll: false,
        compress: true,
        reportProgress: (fileIndex, written, total) => {
          const pct = total ? Math.round((written / total) * 100) : 0;
          setProgress('myBarDevice', pct);
          totalPercentsDevice[3] = pct;
          const avg = Math.round(totalPercentsDevice.reduce((a, b) => a + b, 0) / totalPercentsDevice.length);
          setProgress('myBarDeviceTotal', avg);
          term.writeln(`percentage: ${pct}`);
        },
        calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
      } as FlashOptions;
      await esploader.writeFlash(flashOptionsApp0);
    } catch (e) {
      console.error(e);
      term.writeln(`Error: ${e.message}`);
      hideSpinner();
      showStatus(`Error: ${e.message}`, 'error', 0);
      deviceUpdate.disabled = false;
      dongleUpdate.disabled = false;
      return;
    }

    hideSpinner();
    showStatus('Dongle updated successfully — please restart the device.', 'success', 0);
    deviceUpdate.disabled = false;
    dongleUpdate.disabled = false;
  }
};


/**
 * The built in HTMLTableRowElement object.
 * @external HTMLTableRowElement
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableRowElement}
 */

/**
 * Remove file row from HTML Table
 * @param {HTMLTableRowElement} row Table row element to remove
 */
// removed unused helper `removeRow` as it caused lint warnings

/**
 * Clean devices variables on chip disconnect. Remove stale references if any.
 */
function cleanUp() {
  device = null;
  transport = null;
}

let isConsoleClosed = false;
consoleStartButton.onclick = async () => {
  if (device === null) {
    device = await navigator.serial.requestPort({});
    transport = new Transport(device, true);
  }
  lblConsoleFor.style.display = "block";
  lblConsoleBaudrate.style.display = "none";
  consoleStartButton.style.display = "none";
  consoleStopButton.style.display = "initial";
  programDiv.style.display = "none";

  await transport.connect(921600);
  isConsoleClosed = false;

  while (true && !isConsoleClosed) {
    const val = await transport.rawRead();
    if (typeof val !== "undefined") {
      term.write(val);
    } else {
      break;
    }
  }
  console.log("quitting console");
};

consoleStopButton.onclick = async () => {
  isConsoleClosed = true;
  if (transport) {
    await transport.disconnect();
    await transport.waitForUnlock(1500);
  }
  term.reset();
  lblConsoleBaudrate.style.display = "initial";
  consoleStartButton.style.display = "initial";
  consoleStopButton.style.display = "none";
  lblConsoleFor.style.display = "none";
  programDiv.style.display = "initial";
  cleanUp();
};


function arrayBufferToBinaryString(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
}
async function fetchBinaryFile(url) {
  let output: string;
  console.log('fetchBinaryFile');
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    // Read the response as an ArrayBuffer
    const arrayBuffer = await response.arrayBuffer();

    // Convert ArrayBuffer to binary string
    output = arrayBufferToBinaryString(arrayBuffer);
    console.log('Binary string:', output.length);
  } catch (error) {
    console.error('Failed to fetch file:', error);
  }
  return output;
}

